export default "__VITE_ASSET__8d95180c__"